import React, { useEffect } from "react";

import { openCookiePreferences, toggleCookieBannerVisibility, useTranslation } from "utils";

import { Button, Flex, Icon, Typography } from "components";

export const VideoCookieConsentReminder = () => {
  const { t } = useTranslation("global");

  useEffect(() => {
    toggleCookieBannerVisibility(false);
    return () => toggleCookieBannerVisibility(true);
  }, []);

  return (
    <Flex vertical align="center" justify="center" gap={16} className="video-cookie-consent-reminder" data-testid="video-cookie-consent-reminder">
      <Icon iconName="tabler/cookie" size={48} color="#fff" />
      <Flex vertical align="center" gap={4}>
        <Typography variant="h5" bold color="white">
          {t("videoCookieConsent.title")}
        </Typography>
        <Typography variant="paragraph-m" color="white" className="video-cookie-consent-reminder-description">
          {t("videoCookieConsent.description")}
        </Typography>
      </Flex>
      <Button type="light primary" size="small" onClick={openCookiePreferences} dataTestId="video-cookie-consent-reminder-button">
        {t("videoCookieConsent.buttonText")}
      </Button>
    </Flex>
  );
};

export default VideoCookieConsentReminder;
